import useUser from '@hooks/auth/useUser';
import useAppScheme from '@hooks/native/useAppScheme';
import useScript from '@hooks/useScript';

interface Props {
    itemName: string;
    paymentAmount: number;
    orderNo: string;
    mallId: string;
    returnUri: string;
    requestedAt: string;
    hashString: string;
}

function useNicePay() {
    useScript({ src: import.meta.env.VITE_NICE_PAY_SCRIPT_URL });
    const { user } = useUser();
    const wapUrl = useAppScheme();

    const addToForm = ({ form, name, value }:{
        form: HTMLFormElement,
        name: string;
        value: string;
    }) => {
        const input = document.createElement('input');
        input.name = name;
        input.value = value;
        form.append(input);
    };

    return ({
        itemName, paymentAmount, returnUri, orderNo, mallId,
        requestedAt, hashString,
    }:Props) => {
        const form = document.createElement('form');
        form.method = 'post';
        form.action = '';
        form.acceptCharset = 'euc-kr';
        form.hidden = true;
        addToForm({ form, name: 'PayMethod', value: 'CARD' });
        addToForm({ form, name: 'GoodsName', value: itemName });
        addToForm({ form, name: 'Amt', value: paymentAmount.toString() });
        addToForm({ form, name: 'MID', value: mallId });
        addToForm({ form, name: 'Moid', value: orderNo });
        addToForm({ form, name: 'BuyerName', value: user?.nickname || '고객님' });
        addToForm({ form, name: 'ReturnURL', value: returnUri });
        addToForm({ form, name: 'EdiDate', value: requestedAt });
        addToForm({ form, name: 'SignData', value: hashString });
        addToForm({ form, name: 'CharSet', value: 'euc-kr' });
        if (wapUrl) {
            addToForm({ form, name: 'WapUrl', value: `${wapUrl}://` });
        }

        document.body.append(form);

        // @ts-ignore
        goPay(form);

        return () => {
            form.remove();
        };
    };
}

export default useNicePay;
